import Pet from '~models/pet'

type TextFormat = 'default' | 'informal'
type FormatTable = Readonly<{
  [key in TextFormat]: {
    [key in Pet.Gender]: string
  }
}>

export const convertPetGender = (gender?: Pet.Gender | null, format: TextFormat = 'default') => {
  const formatTable: FormatTable = {
    default: {
      [Pet.Gender.Male]: 'Male',
      [Pet.Gender.Female]: 'Female',
      [Pet.Gender.Unknown]: 'Unknown',
    },
    informal: {
      [Pet.Gender.Male]: 'Boy',
      [Pet.Gender.Female]: 'Girl',
      [Pet.Gender.Unknown]: `I'm not sure`,
    },
  }

  const isNull = typeof gender === 'undefined' || gender === null

  if (isNull) {
    return formatTable[format][Pet.Gender.Unknown]
  }

  return formatTable[format][gender]
}

export default convertPetGender
